module.exports = {
  /*
   * 标题
   */
  title: '互发厨具HUFA Kitchenware',

  /*
   * 简述
   */
  resume: {
    title: '互发不锈钢制品厂 Hufa Stainless Steel Factory',
    desc:
      '潮州市潮安区彩塘镇互发不锈钢制品厂，已成立二十多年。我厂以自主研发部门，市场运营和质量检测部门为核心，设有模具制作车间，硅胶生产车间，不锈钢产品制作车间，和包装加工车间，面积约9800平方米,拥有五十台大吨位的液压机和自动化数控冲床。深耕不锈钢厨房用品二十多年，厂里已通过国际质量认证体系-ISO9001认证，多项产品先后获得国家外观专利证书，以及SGS机构颁发的FDA,LFGB,EU检验证书。主营产品有：不锈钢吸管，不锈钢餐盘，不锈钢沙拉盆，不锈钢份数盆，不锈钢快餐炉，硅胶餐具及其配件等厨房和酒店用品用品。通过直接合作和间接合作的方式，我司产品远销全世界140个国家，成为国际品牌：易初莲花，沃尔玛，可口可乐，星巴克，ZEPTER,Hisense等优质供应商。Hufa Stainless Steel Factory has a long glorious history. It has been founded over 25 years in “the Stainless Steel Kingdom”—Caitang Town,Chaoan County,Chaozhou City,Guangdong Province,China.Our factory takes independent research & design, marketing and quality inspection as the core. We have our own mould workshop,material workshop, stainless steel products workshop and silicone kitchenware workshop.Occupied with an area of 9800 ㎡,it is equipped with over 50 large tonnage hydraulic presses and automated CNC punch presses. With advanced complete facilities and assembly lines,it can produce over 600 kinds of products with about 100 series. Devoted to stainless steel kitchenware production for over 25 years, our factory has passed the international quality certification system - ISO9001 certification and a number of products have obtained the national appearance patent certificate, and the FDA, LFGB, EU inspection certificate issued by the SGS organization.Our main products are: stainless steel straws,plates,mixing bowls, pots, chaffing dish, silicone tableware and other kitchen and hotel supplies. Through direct or indirect cooperation, our products are exported to 140 countries around the world and become the supplier for many international brands,which include: Lotus, Wal-Mart, Coca-Cola, Starbucks, Zepter, Hisense and so on.',
    img: {
      title: 'CERTIFICATES 企业资质',
      src: [
        'static/resume/1.png',
        'static/resume/2.png',
        ['static/resume/301.png', 'static/resume/302.png'],
        ['static/resume/401.png', 'static/resume/402.png'],
        ['static/resume/501.png', 'static/resume/502.png'],
        ['static/resume/601.png', 'static/resume/602.png']
      ]
    }
  },

  /*
   * 文件地址
   */
  appUrl: '93vr.com',

  /*
   * 子级目录文件名
   */
  publicPath: '/hufa',

  https: true,

  /*
   * PHP访问地址
   */
  apiUrl: 'php/new.php',

  /*
   * ifrmae访问地址
   */
  iframeUrl: 'https://my.93vr.com/show/index2.html?m=MjTVAfDes1T&help=0&play=1&qs=1&gt=0&hr=0',

  /*
   * 背景音乐访问地址
   */
  defaultMusic: 'https://matcdn.93vr.com/mp3/hufa/bg.mp3',

  /*
   * 封面状态
   */
  showthumb: true,

  /*
   * 封面 PC端
   */
  thumbPC: 'https://my.93vr.com/hufa/thumb.jpg',

  /*
   * 封面 移动端
   */
  thumbMobile: 'https://my.93vr.com/hufa/thumbMobile.jpg'
}
